export default function buildPatchSalePoint({
    apiEndpoint,
    apiTools
}) {
    return async function patchSalePoint(args) {
        const url = apiTools.resolveUrl({
            ...args,
            apiEndpoint: `${ apiEndpoint }`
        })

        const res = await fetch(url, {
            method: 'PATCH',
            headers: {
                'Content-type': 'application/json'
            },
            credentials: 'include',
            body: args.body
        });
        return await res.json();
    }
}